// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"6bccc3b6","876":"daad53cf"}[chunkId] + ".chunk.js";
};